/**
 * Mapping from SEB Question Options to Character (Behavior) Test Axes
 * Each question has 4 options (0-3).
 * Each option can affect multiple character axes.
 */
export const MEGA_MAPPING = {
    // SEB Axis S Questions (1-10)
    1: [
        { action_initiation: 2, flexibility: 1 }, // 몸이 먼저 움직인다
        { decision_style: 1, action_initiation: 1 }, // 도움을 찾는다
        { reflection: 2, decision_style: -1 }, // 정리해 본다
        { flexibility: 2, value_priority: 1 } // 대안 실행
    ],
    2: [
        { emotional_response: 2, action_initiation: 1 },
        { decision_style: -1, self_vs_other: -1 },
        { self_vs_other: -2, reflection: 1 },
        { reflection: -1, emotional_response: -2 }
    ],
    3: [
        { emotional_response: 2, self_vs_other: 1 },
        { reflection: 2, action_initiation: -1 },
        { action_initiation: 2, flexibility: 1 },
        { consistency: 2, emotional_response: -2 }
    ],
    4: [
        { emotional_response: 2, action_initiation: 1 },
        { reflection: 2, emotional_response: 1 },
        { emotional_response: -2, consistency: 1 },
        { reflection: -1, flexibility: 1 }
    ],
    5: [
        { reflection: 2, emotional_response: -1 },
        { emotional_response: 2, self_vs_other: -1 },
        { reflection: 1, decision_style: -1 },
        { action_initiation: 2, flexibility: 2 }
    ],
    6: [
        { self_vs_other: 2, action_initiation: 2 },
        { reflection: 2, perception_gap: 1 },
        { flexibility: -2, consistency: 1 },
        { flexibility: 2, reflection: -1 }
    ],
    7: [
        { decision_style: 1, emotional_response: 1 },
        { reflection: 2, consistency: 1 },
        { flexibility: 1, self_vs_other: -1 },
        { consistency: 1, self_vs_other: -2 }
    ],
    8: [
        { perception_gap: 1, reflection: 1 },
        { emotional_response: 2, self_vs_other: 1 },
        { consistency: 1, reflection: -1 },
        { reflection: -1, perception_gap: -1 }
    ],
    9: [
        { emotional_response: 2, self_vs_other: 1 },
        { reflection: 2, action_initiation: -2 },
        { flexibility: 2, action_initiation: 1 },
        { flexibility: 2, reflection: -1 }
    ],
    10: [
        { self_vs_other: 2, emotional_response: 1 },
        { emotional_response: 2, perception_gap: 1 },
        { consistency: 1, reflection: 1 },
        { value_priority: -2, reflection: 1 }
    ],
    // SEB Axis E Questions (11-20)
    11: [
        { value_priority: 2, emotional_response: -2 },
        { self_vs_other: -1, action_initiation: 1 },
        { reflection: 2, self_vs_other: -1 },
        { emotional_response: 2, self_vs_other: -2 }
    ],
    12: [
        { value_priority: 2, consistency: 1 },
        { emotional_response: -2, reflection: 1 },
        { reflection: 2, self_vs_other: -1 },
        { flexibility: 2, emotional_response: 2 }
    ],
    13: [
        { emotional_response: -2, reflection: -1 },
        { action_initiation: 1, value_priority: 1 },
        { reflection: 2, self_vs_other: 1 },
        { emotional_response: 2, self_vs_other: -2 }
    ],
    14: [
        { reflection: -1, perception_gap: -1 },
        { consistency: 1, reflection: -1 },
        { reflection: 2, perception_gap: 1 },
        { perception_gap: 2, reflection: 2 }
    ],
    15: [
        { self_vs_other: 2, value_priority: 2 },
        { reflection: 1, self_vs_other: -1 },
        { self_vs_other: -2, emotional_response: 1 },
        { reflection: 2, perception_gap: 2 }
    ],
    16: [
        { decision_style: 1, value_priority: 1 },
        { reflection: -1, consistency: 1 },
        { reflection: 1, flexibility: 2 },
        { reflection: 2, emotional_response: 2 }
    ],
    17: [
        { decision_style: 2, action_initiation: 2 },
        { value_priority: 2, reflection: 1 },
        { reflection: 2, perception_gap: 1 },
        { value_priority: 1, self_vs_other: -1 }
    ],
    18: [
        { perception_gap: -1, self_vs_other: -1 },
        { reflection: -1, consistency: 1 },
        { perception_gap: 2, reflection: 1 },
        { reflection: 2, self_vs_other: -1 }
    ],
    19: [
        { reflection: -1, flexibility: 1 },
        { emotional_response: -2, consistency: 1 },
        { reflection: 2, perception_gap: 1 },
        { emotional_response: 2, reflection: 1 }
    ],
    20: [
        { decision_style: 1, action_initiation: 1 },
        { reflection: 1, self_vs_other: -1 },
        { reflection: 2, perception_gap: 2 },
        { perception_gap: 2, reflection: 2 }
    ],
    // SEB Axis F Questions (21-30)
    21: [
        { self_vs_other: -1, reflection: 1 },
        { reflection: 1, consistency: 1 },
        { consistency: 2, action_initiation: 1 },
        { consistency: 2, value_priority: 2 }
    ],
    22: [
        { decision_style: 1, flexibility: 1 },
        { self_vs_other: -1, reflection: 1 },
        { reflection: 1, decision_style: -1 },
        { consistency: 2, value_priority: 1 }
    ],
    23: [
        { flexibility: 2, self_vs_other: 1 },
        { reflection: 1, consistency: 1 },
        { value_priority: 2, action_initiation: 1 },
        { consistency: 2, value_priority: 2 }
    ],
    24: [
        { self_vs_other: -2, flexibility: 2 },
        { self_vs_other: -1, flexibility: 1 },
        { reflection: 1, value_priority: 1 },
        { self_vs_other: 2, value_priority: 2 }
    ],
    25: [
        { decision_style: 1, value_priority: 2 },
        { reflection: 1, self_vs_other: -1 },
        { reflection: 2, action_initiation: -1 },
        { self_vs_other: 2, consistency: 2 }
    ],
    26: [
        { self_vs_other: 2, emotional_response: -1 },
        { consistency: 1, self_vs_other: -1 },
        { consistency: 2, value_priority: 1 },
        { self_vs_other: -2, consistency: 2 }
    ],
    27: [
        { self_vs_other: 1, reflection: -2 },
        { reflection: -1, value_priority: 1 },
        { reflection: 1, consistency: 1 },
        { consistency: 2, value_priority: 2 }
    ],
    28: [
        { flexibility: 2, reflection: 1 },
        { self_vs_other: -2, reflection: 2 },
        { consistency: 1, reflection: 1 },
        { consistency: 2, self_vs_other: 2 }
    ],
    29: [
        { self_vs_other: 1, reflection: -1 },
        { reflection: -1, consistency: 1 },
        { reflection: 1, self_vs_other: 1 },
        { self_vs_other: 2, consistency: 2 }
    ],
    30: [
        { self_vs_other: 2, reflection: 1 },
        { reflection: 1, action_initiation: -1 },
        { action_initiation: 1, consistency: 1 },
        { action_initiation: 2, consistency: 2 }
    ]
};
